import { groq } from 'next-sanity';
import type { PortableTextBlock as PortableTextBlockType } from 'next-sanity';
import { z } from 'zod';

import { link } from './link';

// @ts-expect-error it doesn't like the Sanity responds with null but its fine
const PortableTextBlock: z.ZodType<PortableTextBlockType> = z.looseObject({
  _type: z.union([z.literal('block'), z.string()]),
  _key: z.string().optional(),
  children: z.array(z.any()).optional(),
  markDefs: z.array(z.any()).optional().nullable(),
  style: z.any().optional(),
  listItem: z.any().optional(),
  level: z.number().optional(),
});
export const SanityBasicText = z.array(PortableTextBlock);
export type SanityBasicText = z.infer<typeof SanityBasicText>;

export const basicText = groq`{
  ...,
  markDefs[] ${link},
}`;
